import { combineReducers } from 'redux';

import faqUnreleasedImageryReducer from './UnreleasedImageryPage';
import homeHeroReducer from './HomeHero';
import homeReducer from './HomePage';
import inspirePageReducer from './InspirePages';
import musicPageReducer from './MusicPage';
import videoEditorReducer from './VideoEditor';
import videoLandingPageReducer from './VideoLandingPage';
import headerReducer from './Header';
import userReducer from './User';
import creativeImageHomeReducer from './CreativeImageHome';
import aiLandingPageReducer from './AiLandingPage';
import videoTemplatePageReducer from './VideoTemplatePage';

const rootReducer = combineReducers({
  faqUnreleasedImagery: faqUnreleasedImageryReducer,
  headerData: headerReducer,
  homeHero: homeHeroReducer,
  homePageData: homeReducer,
  inspirePageData: inspirePageReducer,
  musicPageData: musicPageReducer,
  user: userReducer,
  videoEditor: videoEditorReducer,
  videoLandingPageData: videoLandingPageReducer,
  creativeImageHomeData: creativeImageHomeReducer,
  aiLandingPageData: aiLandingPageReducer,
  videoTemplatePageData: videoTemplatePageReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
